const API_KEY = "02581a4d0ea33802e6d1b5670847636a";

export default API_KEY;